var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel-item',{attrs:{"field":_vm.field}},[_c('template',{slot:"value"},[_c('div',{staticClass:"ckeditor_content"},[_c('excerpt',{attrs:{"content":_vm.field.value,"should-show":_vm.field.shouldShow,"plain-text":false}})],1)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }